// Copyright (C) 2021 Bystronic Laser AG

import AuthService from '@/services/auth.service';

export const authServicePlugin = {
  install(vue: any) {
    vue.prototype.$auth = new AuthService();
  },
};
